import {get} from 'lodash';

export const updateSearchResults = (
  state = {},
  {
    searchInput,
    results,
    responseHeaders,
    isEndReached,
    appendData,
    filterParam = 'default',
    filterByValue = '',
    sortBy = '',
    sortOrder = '',
  }: any,
) => ({
  ...state,
  allSearchResults: {
    ...get(state, 'allSearchResults', {}),
    [`${searchInput}-${sortBy}-${sortOrder}-${filterParam}-${filterByValue}-Filters-N/A`]:
      appendData
        ? [
            ...get(
              state,
              `allSearchResults.${searchInput}-${sortBy}-${sortOrder}-${filterParam}-${filterByValue}-Filters-N/A`,
              [],
            ),
            ...results,
          ]
        : results,
  },
  allSearchMeta: {
    ...get(state, 'allSearchMeta', {}),
    [`${searchInput}-${sortBy}-${sortOrder}-${filterParam}-${filterByValue}-Filters-N/A`]:
      {
        ...get(
          state,
          `allSearchMeta.${searchInput}-${sortBy}-${sortOrder}-${filterParam}-${filterByValue}-Filters-N/A`,
          {},
        ),
        size: responseHeaders[0],
        isEndReached,
      },
  },
});
